/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type OngoingAutomationResponse = ApiResponse & {
  data: OngoingAutomation[];
};

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface OngoingAutomation {
  /** 알고리즘 ID */
  algorithmId: string;
  /** 알고리즘 이름 */
  algorithmName: string;
  /** 알고리즘이 적용된 국적 이름 목록 */
  appliedNationalityNames: string[];
  /** 폴더에 속하지 않은 태그 목록 */
  tagsHaveNoFolder: {
    /**
     * 치료 태그 ID
     * @example "5f9b3b4e1c9d440000000001"
     */
    tagId: string;
    /**
     * 치료 태그 이름
     * @example "보톡스 윤곽"
     */
    tagName: string;
    /**
     * 태그 색상
     * @example "#FF0000"
     */
    tagColor?: string;
  }[];
  /** 폴더에 속한 태그 목록 */
  tagsHaveFolder: {
    /**
     * 폴더 ID
     * @example "5f9b3b4e1c9d440000000001"
     */
    folderID: string;
    /**
     * 폴더 이름
     * @example "피부 관리 시술"
     */
    folderName: string;
    /** 폴더에 속한 태그 목록 */
    tags: {
      /**
       * 치료 태그 ID
       * @example "5f9b3b4e1c9d440000000001"
       */
      tagId: string;
      /**
       * 치료 태그 이름
       * @example "보톡스 윤곽"
       */
      tagName: string;
      /**
       * 태그 색상
       * @example "#FF0000"
       */
      tagColor?: string;
    }[];
  }[];
  /** 알고리즘이 적용된 태그 이름 목록 */
  appliedTagNames?: string[];
}

export interface AlgorithmWithMessagesInput {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 알고리즘의 이름
   * @example "마케팅 캠페인"
   */
  name: string;
  /**
   * 알고리즘의 유형 - 상담, 마케팅
   * @example "CONSULTATION"
   */
  type: "CONSULTATION" | "MARKETING";
  /**
   * 대상 치료 태그 아이디 목록
   * @example ["66ac4be507a37e99d4ae626a","66ac4be507a37e99d4ae626b"]
   */
  targetTreatmentTags?: string[];
  /**
   * 마케팅 자동화 등록 시점에 치료 태그 없음을 선택하는 경우
   * @example false
   */
  isForNoTreatmentTags?: boolean;
  /**
   * 마케팅 자동화 등록 시점에 국적 없음을 선택하는 경우
   * @example false
   */
  isForNoNationality?: boolean;
  /** 알고리즘 발송 스케줄 */
  sendingSchedule?: {
    /**
     * 알고리즘 발송 시작 날짜 - 공통 알고리즘의 경우 시각 데이터만 사용
     * @format date-time
     * @example "2024-08-14T00:00:00Z"
     */
    startDay: string;
    /**
     * 최대 발송 회차 - 마케팅 알고리즘만 해당
     * @example 5
     */
    sendingCount?: number;
  };
  /** 공통 알고리즘 정보 */
  commonAlgorithm?: {
    /**
     * 공통 알고리즘 활성화 여부
     * @example true
     */
    enabled: boolean;
    /**
     * 알고리즘 시작 후 며칠 후에 공통 알고리즘 메시지를 발송할지를 설정
     * @min 1
     * @max 365
     * @example 7
     */
    sendingDaysAfterStart?: number;
  };
  /** 메시지 목록 */
  messages: MessageInput[];
  /**
   * 적용할 국적 아이디 목록
   * @example ["66a9d61907a37e99d4ae6250","66a9d61907a37e99d4ae6251"]
   */
  toBeAppliedNationalityIds?: string[];
  /**
   * 카카오 알림톡 템플릿 이력 ID - 기존 검수 템플릿을 사용하는 경우에만 필요
   * @example "67623667bcd09a0a8787c25c"
   */
  kakaoTemplateHistoryId?: string;
}

export interface MessageInput {
  /**
   * 메시지의 이름
   * @example "환영 메시지"
   */
  name: string;
  /**
   * 메시지의 유형 - 기본(BASIC), 재내원유도 필수 메시지(REVISIT_INDUCEMENT), 설문(SURVEY), 브랜드 메시지(BRAND_MESSAGE)
   * @example "BASIC"
   */
  sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "BRAND_MESSAGE";
  /**
   * 메시지 전송 날짜 - 마케팅 알고리즘에서만 사용되는 필드
   * @format date-time
   * @example "2024-08-15T00:00:00Z"
   */
  sendingDateTime?: string;
  /**
   * 며칠 후 보내야 하는지에 대한 데이터 - 상담 알고리즘에서만 사용되는 필드
   * @example 7
   */
  daysAfter?: number;
  /**
   * 발송 시간 - 상담 알고리즘에서만 사용되는 필드
   * @example "09:30"
   */
  timeOfDay?: string;
  /** 메시지 내용 */
  content: {
    /**
     * 메시지 텍스트
     * @example "안녕하세요!"
     */
    text?: string;
    /**
     * 이미지 업로드 이후 생성된 파일 ID - 이미지 업로드 시 클라이언트 측에서 상담 자동화 메시지의 경우 이미지 개수 20개까지 마케팅 자동화의 경우 이미지 개수 1개까지 업로드 제한하는 로직 필요
     * @example "66f11a223a4e84397d604db7"
     */
    image?: string;
    /**
     * 비디오 업로드 이후 생성된 파일 ID - 상담 알고리즘에서만 사용되는 필드 - 비디오 업로드 시 클라이언트 측에서 비디오 개수 1개까지 업로드 제한하는 로직 필요
     * @example "66c594000469d43a28d5cde7"
     */
    video?: string;
    /**
     * 비디오 콘텐츠 ID - 운동 영상 - 상담 알고리즘에서만 사용되는 필드 - VideoContent 컬렉션 ID
     * @example "63d1db9d813fcf1c99a34f18"
     */
    workoutVideo?: string;
    /**
     * 병원 콘텐츠 ID - 상담 알고리즘에서만 사용되는 필드 - HospitalAftercare 컬렉션 ID
     * @example "66da9fb0b0acc956b4b723e4"
     */
    homecareContent?: string;
    /**
     * 이벤트 ID - 상담 알고리즘에서만 사용되는 필드 - HospitalEvent 컬렉션 ID
     * @example "633d07bc828afe1f2ce8c504"
     */
    event?: string;
    /** 설문 정보 */
    survey?: {
      /**
       * 설문 질문
       * @example "설문 질문"
       */
      question?: string;
      /**
       * 설문 옵션 목록
       * @example ["옵션1","옵션2"]
       */
      answers?: string[];
    };
  };
  /**
   * 상담 가이드 표시 여부
   * @example true
   */
  showConsultationGuide?: boolean;
  /**
   * 상담 가이드 내용
   * @example "상담 가이드"
   */
  consultationGuide?: string;
  /** sendingType 이 BRAND_MESSAGE 일 때 사용하는 본문/타깃팅 */
  brandMessage?: {
    content?: {
      text?: Record<string, any>;
      image?: Record<string, any>;
      wideImage?: Record<string, any>;
      carousel?: Record<string, any>[];
    };
    targeting?: "M" | "N" | "I";
  };
}

export interface AlgorithmCreationResponse {
  /**
   * 알고리즘 생성 성공 여부
   * @example true
   */
  isCreatedSucess: boolean;
  /**
   * 생성된 알고리즘 아이디
   * @example "66ac86ce07a37e99d4ae62c4"
   */
  createdAlgorithmId: string;
  /**
   * 적용된 환자 수 - 마케팅 알고리즘만 해당
   * @example 100
   */
  appliedPatientCount?: number;
}

export interface AlgorithmControllerDeleteAlgorithmResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export interface AlgorithmDeletionRequest {
  /** 삭제할 알고리즘 ID */
  algorithmId?: string;
}

export interface AutomationMain {
  /** 상담 알고리즘 목록 */
  consultationAlgorithms?: AlgorithmSummary[];
  /** 마케팅 알고리즘 목록 */
  marketingAlgorithms?: AlgorithmSummary[];
}

export interface AlgorithmSummary {
  /**
   * 알고리즘 ID
   * @example "66ac87aa07a37e99d4ae62ca"
   */
  _id: string;
  /**
   * 알고리즘 이름
   * @example "쁘띠 시술 후 관리"
   */
  name: string;
  /**
   * 활성화 여부
   * @example true
   */
  isActive: boolean;
  /**
   * 자동화 알고리즘 유형
   * @example "CONSULTATION"
   */
  type: "CONSULTATION" | "MARKETING";
  /** 대상 치료 태그 정보 목록 */
  treatmentTags?: MatchedTreatmentTag[];
  /** 대상 국적 정보 목록 */
  nationalities?: MatchedNationality[];
  /**
   * 마케팅 자동화 등록 시점에 치료 태그 없음을 선택하는 경우
   * @example false
   */
  isForNoTreatmentTags?: boolean;
  /**
   * 마케팅 자동화 등록 시점에 국적 없음을 선택하는 경우
   * @example false
   */
  isForNoNationality?: boolean;
  /**
   * 대상자 수
   * @example 150
   */
  targetCount: number;
  /**
   * 조회 수
   * @example 120
   */
  readCount: number;
  /**
   * 응답 수
   * @example 15
   */
  responseCount: number;
  /**
   * 총 자동화 적용 건수 (발송이력 distinct hserviceID)
   * @example 42
   */
  targetPatientCount?: number;
  /**
   * 메시지 전송 건수 (성공 발송 건수 합)
   * @example 128
   */
  sentMessageCount?: number;
}

export interface MatchedTreatmentTag {
  /**
   * 알고리즘 ID
   * @example "66ac87aa07a37e99d4ae62ca"
   */
  _id: string;
  /**
   * 치료 태그 이름
   * @example "코필러"
   */
  categoryName: string;
  /**
   * 치료 태그 색상
   * @example "#FF5733"
   */
  color: string;
}

export interface MatchedNationality {
  /**
   * 국적 ID
   * @example "66ac87aa07a37e99d4ae62ca"
   */
  _id: string;
  /**
   * 국적 한글 이름
   * @example "한국"
   */
  koreanCountryName: string;
  /**
   * 국제 전화 코드
   * @example "+82"
   */
  internationalDialingCodes: string;
  /**
   * ISO Alpha 2 코드
   * @example "KR"
   */
  countryCodeISOAlpha2: string;
  /**
   * ISO Alpha 3 코드
   * @example "KOR"
   */
  countryCodeISOAlpha3: string;
  /**
   * 국적 영문 이름
   * @example "South Korea"
   */
  englishCountryName: string;
}

export interface Dashboard {
  /** 관리 고객 수 */
  managedCustomers?: CustomerCountData;
  /** 활성 고객 수 */
  activeCustomers?: CustomerCountData;
  /** 상담 완료율 */
  consultationCompletionRate?: ConsultationCompletionData;
  /** 상담 응답 속도 */
  consultationResponseSpeed?: ConsultationSpeedData;
}

export interface CustomerCountData {
  /**
   * 총 고객 수
   * @example 5000
   */
  total?: number;
  /**
   * 지난달 대비 변화 수
   * @example 100
   */
  changeFromLastMonth?: number;
  monthlyCounts?: {
    /**
     * 연도
     * @example 2023
     */
    year?: number;
    /**
     * 월
     * @example 4
     */
    month?: number;
    /**
     * 고객 수
     * @example 2950
     */
    count?: number;
  }[];
}

export interface ConsultationCompletionData {
  /**
   * 완료율
   * @example 75.5
   */
  completionRate?: number;
  /**
   * 지난달 대비 변화율
   * @example 2.5
   */
  changeFromLastMonth?: number;
  /**
   * 새로운 상담 수
   * @example 500
   */
  newConsultations?: number;
  /**
   * 미완료 상담 수
   * @example 100
   */
  incompleteConsultations?: number;
}

export interface ConsultationSpeedData {
  /**
   * 평균 응답 시간
   * @example 300
   */
  averageResponseTime?: number;
  /**
   * 지난달 대비 변화 시간
   * @example -30
   */
  changeFromLastMonth?: number;
  topConsultants?: {
    /**
     * 상담사 이름
     * @example "김상담"
     */
    name?: string;
    /**
     * 평균 응답 시간
     * @example 240
     */
    averageResponseTime?: number;
  }[];
}

export interface AlgorithmMessage {
  /**
   * 메시지 ID
   * @example "12345"
   */
  id: string;
  /**
   * 공통 재내원 메시지 여부
   * @example true
   */
  isCommonAlgorithmMessage?: boolean;
  /**
   * 메시지 이름
   * @example "Welcome Message"
   */
  name: string;
  /**
   * 메시지의 유형 - 기본(BASIC), 재내원유도 필수 메시지(REVISIT_INDUCEMENT), 설문(SURVEY), 브랜드 메시지(BRAND_MESSAGE)
   * @example "BASIC"
   */
  sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "BRAND_MESSAGE";
  /**
   * 승인된 알림톡 템플릿 보유 여부 - 상담 자동화 메시지(+공통 재내원 메시지)에만 해당
   * @example true
   */
  hasApprovedAlimtalkTemplate?: boolean;
  /**
   * 알림톡 템플릿 반려 사유 - 해당 값이 한 글자 이상 존재하면 반려 메시지 표시
   * @example "템플릿이 부적합합니다."
   */
  rejectedReasonForAlimtalkTemplate?: string;
  /**
   * 친구톡 전송 가능 메시지 여부 - 사싱상 친구톡 연동 병원 여부 - 마케팅 자동화 메시지에만 해당
   * @example true
   */
  canBeSentToFriendTalk?: boolean;
  /**
   * 카카오 알림톡 템플릿 이력 ID
   * @example "67623667bcd09a0a8787c25c"
   */
  kakaoTemplateHistoryId?: string;
  /**
   * 메시지 전송 날짜 (ISO 8601 형식) - 마케팅 알고리즘에만 해당하고 이 경우 무조건 응답함
   * @format date-time
   * @example "2023-10-01T12:00:00Z"
   */
  sendingDateTime?: string;
  /**
   * 며칠 후 전송하는지에 대한 정보 - 상담 알고리즘에만 해당하고 이 경우 무조건 응답함
   * @example 3
   */
  daysAfter?: number;
  /**
   * 하루 중 전송 시간 - 상담 알고리즘에만 해당하고 이 경우 무조건 응답함
   * @example "09:00"
   */
  timeOfDay?: string;
  /** 메시지 내용 */
  content?: {
    /**
     * 메시지 텍스트
     * @example "Hello, welcome to our service!"
     */
    text: string;
    /**
     * 이미지 URL 배열
     * @example ["https://example.com/image1.jpg","https://example.com/image2.jpg"]
     */
    images?: string[];
    /**
     * 이미지 파일 ID
     * @example "650cf3be0cc5ce37e9d108c0"
     */
    imageFileID?: string;
    video?: {
      /**
       * 비디오 파일 ID
       * @example "60d0fe4f5311236168a109cb"
       */
      _id?: string;
      /**
       * 비디오 URL
       * @example "https://example.com/video.mp4"
       */
      url?: string;
      /**
       * 비디오 파일 이름
       * @example "video.mp4"
       */
      fileName?: string;
      /**
       * 비디오 파일 크기 (바이트 단위)
       * @example 1048576
       */
      fileSize?: number;
    };
    workoutVideo?: {
      /**
       * 운동 영상 비디오 ID - vcID - videocontents 컬렉션 데이터
       * @example "60d0fe4f5311236168a109cc"
       */
      _id?: string;
      /**
       * 운동 영상 비디오 제목
       * @example "운동 비디오 제목"
       */
      title?: string;
      /**
       * 운동 영상 비디오 부제목
       * @example "운동 비디오 부제목"
       */
      subtitle?: string;
      /**
       * 운동 영상 비디오 썸네일 URL
       * @example "https://example.com/thumbnail.jpg"
       */
      thumbnailUrl?: string;
      /**
       * 병원에 종속된 운동 영상 ID - videocontenthospitals 컬렉션 데이터
       * @example "60d0fe4f5311236168a109cc"
       */
      videoContentHospitalID?: string;
    };
    homecareContent?: {
      /**
       * 병원 콘텐츠 ID
       * @example "60d0fe4f5311236168a109cd"
       */
      _id?: string;
      /**
       * 병원 콘텐츠 제목
       * @example "병원 콘텐츠 제목"
       */
      title?: string;
      /**
       * 병원 콘텐츠 가격
       * @example 10000
       */
      price?: number;
      /**
       * 이벤트 활성화 여부
       * @example true
       */
      isActive?: boolean;
      /**
       * 이벤트 기간 제한 여부
       * @example true
       */
      isLimitedTime?: boolean;
      /**
       * 이벤트 삭제 여부
       * @example true
       */
      isRemoved?: boolean;
      /**
       * 할인 유형
       * @example "정액 할인"
       */
      saleType?: string;
      /**
       * 할인 가격
       * @example 8000
       */
      salePrice?: number;
      /**
       * 할인율
       * @example 20
       */
      saleRate?: number;
      /**
       * 썸네일 URL
       * @example "https://example.com/thumbnail.jpg"
       */
      thumbnailUrl?: string;
    };
    event?: {
      /**
       * 이벤트 ID
       * @example "60d0fe4f5311236168a109ce"
       */
      _id?: string;
      /**
       * 이벤트 제목
       * @example "이벤트 제목"
       */
      title?: string;
      /**
       * 이벤트 가격
       * @example 5000
       */
      price?: number;
      /**
       * 이벤트 활성화 여부
       * @example true
       */
      isActive?: boolean;
      /**
       * 이벤트 기간 제한 여부
       * @example true
       */
      isLimitedTime?: boolean;
      /**
       * 이벤트 삭제 여부
       * @example true
       */
      isRemoved?: boolean;
      /**
       * 할인 유형
       * @example "정액 할인"
       */
      saleType?: string;
      /**
       * 할인 가격
       * @example 4000
       */
      salePrice?: number;
      /**
       * 할인율
       * @example 20
       */
      saleRate?: number;
      /**
       * 썸네일 URL
       * @example "https://example.com/thumbnail.jpg"
       */
      thumbnailUrl?: string;
    };
    /** 설문조사 정보 */
    survey?: {
      /**
       * 설문조사 질문
       * @example "How satisfied are you with our service?"
       */
      question?: string;
      /**
       * 설문조사 옵션 배열
       * @example ["Very satisfied","Satisfied","Neutral","Dissatisfied","Very dissatisfied"]
       */
      answers?: string[];
    };
  };
  /**
   * 상담 가이드 표시 여부
   * @example true
   */
  showConsultationGuide: boolean;
  /**
   * 상담 가이드 내용 - showConsultationGuide true인 경우에만 유효
   * @example "상담 후 적절한 조치를 취하세요."
   */
  consultationGuide?: string;
  /**
   * 생성 날짜 (ISO 8601 형식)
   * @format date-time
   * @example "2023-10-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * 수정 날짜 (ISO 8601 형식)
   * @format date-time
   * @example "2023-10-01T12:00:00Z"
   */
  updatedAt: string;
  /** sendingType 이 BRAND_MESSAGE 인 경우 페어링된 본문/타깃팅 */
  brandMessage?: {
    content?: {
      text?: Record<string, any>;
      image?: Record<string, any>;
      wideImage?: Record<string, any>;
      carousel?: Record<string, any>[];
    };
    targeting?: "M" | "N" | "I";
  };
}

export interface NewMessageInput {
  /**
   * 알고리즘 ID
   * @example "66bc697938054e6d5fa3604f"
   */
  algorithmId: string;
  /**
   * 메시지 이름
   * @example "알고리즘 메시지"
   */
  name: string;
  /** 메시지의 유형 - 기본(BASIC), 재내원유도 필수 메시지(REVISIT_INDUCEMENT), 설문(SURVEY), 브랜드 메시지(BRAND_MESSAGE) */
  sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "BRAND_MESSAGE";
  /**
   * 메시지 전송 날짜 - 마케팅 알고리즘에서만 사용되는 필드
   * @format date-time
   * @example "2024-08-15T00:00:00Z"
   */
  sendingDateTime?: string;
  /**
   * 며칠 후 보내야 하는지에 대한 데이터 - 상담 알고리즘에서만 사용되는 필드
   * @example 7
   */
  daysAfter?: number;
  /**
   * 발송 시간 - 상담 알고리즘에서만 사용되는 필드
   * @example "09:30"
   */
  timeOfDay?: string;
  /** 메시지 내용 */
  content: {
    /**
     * 메시지 텍스트
     * @example "안녕하세요!"
     */
    text?: string;
    /**
     * 이미지 업로드 이후 생성된 파일 ID - 이미지 업로드 시 클라이언트 측에서 상담 자동화 메시지의 경우 이미지 개수 20개까지 마케팅 자동화의 경우 이미지 개수 1개까지 업로드 제한하는 로직 필요
     * @example "66f11a223a4e84397d604db7"
     */
    image?: string;
    /**
     * 비디오 업로드 이후 생성된 파일 ID - 상담 알고리즘에서만 사용되는 필드 - 비디오 업로드 시 클라이언트 측에서 비디오 개수 1개까지 업로드 제한하는 로직 필요
     * @example "66c594000469d43a28d5cde7"
     */
    video?: string;
    /**
     * 비디오 콘텐츠 ID - 운동 영상 - 상담 알고리즘에서만 사용되는 필드 - VideoContent 컬렉션 ID
     * @example "63d1db9d813fcf1c99a34f18"
     */
    workoutVideo?: string;
    /**
     * 병원 콘텐츠 ID - 상담 알고리즘에서만 사용되는 필드 - HospitalAftercare 컬렉션 ID
     * @example "66da9fb0b0acc956b4b723e4"
     */
    homecareContent?: string;
    /**
     * 이벤트 ID - 상담 알고리즘에서만 사용되는 필드 - HospitalEvent 컬렉션 ID
     * @example "633d07bc828afe1f2ce8c504"
     */
    event?: string;
    /** 설문 정보 */
    survey?: {
      /**
       * 설문 질문
       * @example "설문 질문"
       */
      question?: string;
      /**
       * 설문 옵션 목록
       * @example ["옵션1","옵션2"]
       */
      answers?: string[];
    };
  };
  /** 브랜드 메시지 본문 - sendingType이 BRAND_MESSAGE일 때만 사용되는 필드 */
  brandMessage?: {
    /** 브랜드 메시지 콘텐츠 (text/image/wideImage/carousel) - 메시지 유형 중 하나가 선택적으로 들어감 */
    content?: {
      /** 텍스트 메시지 */
      text?: Record<string, any>;
      /** 이미지 메시지 */
      image?: Record<string, any>;
      /** 와이드 이미지 메시지 */
      wideImage?: Record<string, any>;
      /** 캐러셀 메시지 */
      carousel?: Record<string, any>[];
    };
    /** 발송 타깃팅 (M: 남성, N: 여성, I: 전체) */
    targeting?: "M" | "N" | "I";
  };
  /**
   * 상담 가이드 표시 여부
   * @example true
   */
  showConsultationGuide?: boolean;
  /**
   * 상담 가이드 내용
   * @example "상담 가이드"
   */
  consultationGuide?: string;
}

export type UpdateMessageInput = NewMessageInput & {
  /**
   * 알고리즘 메시지 ID
   * @example "66c30cb57ae0c769d784db71"
   */
  messageId?: string;
};

export interface DeleteMessageInput {
  /**
   * 삭제할 메시지 ID
   * @example "66c30fd94b3f1d80189c6f3b"
   */
  messageId: string;
}

export interface AlgorithmToggleInput {
  /** 알고리즘 ID */
  algorithmId: string;
  /** 알고리즘 활성화 여부 */
  isActive: boolean;
}

export interface MessageResponse {
  /**
   * 설문 응답 ID
   * @example "66cfd87eb25ef469c57f03fc"
   */
  surveyResponseId: string;
  /**
   * 알고리즘 메시지 ID
   * @example "6698e41735407be74ea17d56"
   */
  algorithmMessageId: string;
  /**
   * 알고리즘 메시지 이름
   * @example "고객 만족도 설문"
   */
  algorithmMessageName: string;
  /**
   * 환자 ID
   * @example "66ceb65989b82a24ee87a3be"
   */
  patientId: string;
  /**
   * 환자 이름
   * @example "홍길동"
   */
  patientName: string;
  /**
   * 환자 차트 번호 - 스마트닥터 연동시 사용
   * @example "12345678"
   */
  chartNumber?: string;
  /**
   * 환자 성별 - M=남성, F=여성
   * @example "M"
   */
  gender?: string;
  /**
   * 환자 생년월일
   * @example "1990-01-01"
   */
  birth?: string;
  /**
   * 환자 전화번호
   * @example "01012345678"
   */
  phone?: string;
  /**
   * 설문 질문
   * @example "저희 서비스에 대해 얼마나 만족하셨나요?"
   */
  surveyQuestion: string;
  /**
   * 선택된 답변
   * @example "매우 만족함"
   */
  selectedAnswer: string;
  /**
   * 선택된 답변의 인덱스 - 0부터 시작
   * @example 3
   */
  answerIndex: number;
  /**
   * 응답 시간
   * @format date-time
   * @example "2024-08-30T00:00:00.000Z"
   */
  answeredAt: string;
  countryCode?: {
    /** 국가 코드 ID */
    _id?: string;
    /** 한국 국가 이름 */
    koreanCountryName?: string;
    /** 국가 코드 */
    internationalDialingCodes?: string;
  } | null;
}

export interface AffectedPatientCount {
  /** 영향 받는 환자 수 */
  affectedPatientCount: number;
}

export interface KakaoTemplateRenewingControllerRenewTemplateStatusesBodyRequest {
  /** true 이면 그룹 템플릿 발신키(MEDIPAL/AFTERDOC)만 처리하고, senderKey 는 무시합니다. */
  forGroupTemplate?: boolean;
  /** forGroupTemplate=false 일 때, 특정 병원의 senderKey. 미지정 시 전체 병원의 senderKey 를 순회합니다. */
  senderKey?: string;
  /**
   * true 이면 kakaoModifiedAt 일치 여부와 관계없이 상세 조회 및 DB 갱신을 수행합니다. 월 1회 전수 업데이트 등에 사용합니다.
   * @default false
   */
  forceDetailUpdate?: boolean;
}

export interface KakaoTemplateRenewingControllerRenewTemplateStatusesResponse {
  code: number;
  data: {
    /** 갱신 처리 완료 여부 */
    hasRenewedTemplate: boolean;
  };
  message: string;
}

export interface AlgorithmControllerGetMarkingTargetCountResponse {
  code: number;
  data: {
    /** 대상 수 */
    targetCount: number;
  };
  message: string;
}

export interface AlgorithmControllerGetMarketingAlgorithmTargetCountBodyRequest {
  tag?: {
    operator: "OR" | "AND";
    treatmentTagIDs: string[];
    noTreatmentTag: boolean;
    customTagIDs: string[];
  };
  extra?: {
    treatmentTagAttachedAt?: {
      type: "AFTER" | "BEFORE";
      date: string;
    };
    tag?: {
      treatmentTagIDs: string[];
      noTreatmentTag: boolean;
      customTagIDs: string[];
    };
    gender?: "M" | "F";
    isFirstVisit?: boolean;
    nationality?: {
      ids: string[];
      noNationality: boolean;
    };
    age?: {
      from?: number;
      to?: number;
    }[];
  };
}

export interface AlgorithmControllerGetMarketingAlgorithmTargetCountResponse {
  code: number;
  data: {
    /** 대상 수 */
    targetCount: number;
  };
  message: string;
}

export interface AlgorithmControllerFindMarketingAlgorithmsResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    isActive: boolean;
    targetCount: number;
    filter?: {
      tag?: {
        operator: "OR" | "AND";
        treatmentTags: {
          _id: string;
          categoryName: string;
          color: string;
          folder?: {
            _id: string;
            name: string;
          };
        }[];
        noTreatmentTag: boolean;
        customTags: {
          _id: string;
          name: string;
          group?: {
            _id: string;
            name: string;
          };
        }[];
      };
      extra?: {
        treatmentTagAttachedAt?: {
          type: "AFTER" | "BEFORE";
          date: string;
        };
        tag?: {
          treatmentTags: {
            _id: string;
            categoryName: string;
            color: string;
            folder?: {
              _id: string;
              name: string;
            };
          }[];
          noTreatmentTag: boolean;
          customTags: {
            _id: string;
            name: string;
            group?: {
              _id: string;
              name: string;
            };
          }[];
        };
        gender?: "M" | "F";
        isFirstVisit?: boolean;
        nationality?: {
          data: {
            _id: string;
            koreanCountryName: string;
            englishCountryName: string;
          }[];
          noNationality: boolean;
        };
        age?: {
          from?: number;
          to?: number;
        }[];
      };
    };
    sentCount: number;
    readCount: number;
  }[];
  message: string;
}

export interface AlgorithmControllerCreateMarketingAlgorithmBodyRequest {
  name: string;
  filter?: {
    tag?: {
      operator: "OR" | "AND";
      treatmentTagIDs: string[];
      noTreatmentTag: boolean;
      customTagIDs: string[];
    };
    extra?: {
      treatmentTagAttachedAt?: {
        type: "AFTER" | "BEFORE";
        date: string;
      };
      tag?: {
        treatmentTagIDs: string[];
        noTreatmentTag: boolean;
        customTagIDs: string[];
      };
      gender?: "M" | "F";
      isFirstVisit?: boolean;
      nationality?: {
        ids: string[];
        noNationality: boolean;
      };
      age?: {
        from?: number;
        to?: number;
      }[];
    };
  };
  messages: {
    _id?: string;
    name: string;
    sendingDateTime: string;
    content: {
      text?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
      };
      image?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      wideImage?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      carousel?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        title: string;
        text: string;
        imageUrl: string;
        imageLink?: string;
      }[];
    };
    targeting?: "M" | "N" | "I";
  }[];
}

export interface AlgorithmControllerCreateMarketingAlgorithmResponse {
  code: number;
  data: {
    isCreatedSuccess: boolean;
    createdAlgorithmId: string;
    appliedPatientCount: number;
  };
  message: string;
}

export interface AlgorithmControllerUpdateMarketingAlgorithmBodyRequest {
  _id: string;
  name: string;
  messages: {
    _id?: string;
    name: string;
    sendingDateTime: string;
    content: {
      text?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
      };
      image?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      wideImage?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      carousel?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        title: string;
        text: string;
        imageUrl: string;
        imageLink?: string;
      }[];
    };
    targeting?: "M" | "N" | "I";
  }[];
}

export interface AlgorithmControllerUpdateMarketingAlgorithmResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export interface AlgorithmControllerFindMarketingAlgorithmResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    isActive: boolean;
    targetCount: number;
    filter?: {
      tag?: {
        operator: "OR" | "AND";
        treatmentTags: {
          _id: string;
          categoryName: string;
          color: string;
          folder?: {
            _id: string;
            name: string;
          };
        }[];
        noTreatmentTag: boolean;
        customTags: {
          _id: string;
          name: string;
          group?: {
            _id: string;
            name: string;
          };
        }[];
      };
      extra?: {
        treatmentTagAttachedAt?: {
          type: "AFTER" | "BEFORE";
          date: string;
        };
        tag?: {
          treatmentTags: {
            _id: string;
            categoryName: string;
            color: string;
            folder?: {
              _id: string;
              name: string;
            };
          }[];
          noTreatmentTag: boolean;
          customTags: {
            _id: string;
            name: string;
            group?: {
              _id: string;
              name: string;
            };
          }[];
        };
        gender?: "M" | "F";
        isFirstVisit?: boolean;
        nationality?: {
          data: {
            _id: string;
            koreanCountryName: string;
            englishCountryName: string;
          }[];
          noNationality: boolean;
        };
        age?: {
          from?: number;
          to?: number;
        }[];
      };
    };
    messages: {
      _id: string;
      name: string;
      sendingDateTime: string;
      content: {
        text?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
        };
        image?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        wideImage?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        carousel?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          title: string;
          text: string;
          imageUrl: string;
          imageLink?: string;
        }[];
      };
      targeting?: "M" | "N" | "I";
    }[];
  };
  message: string;
}

export interface AlgorithmControllerFindAlgorithmMessageResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    algorithmID: string;
    algorithmName: string;
    sendingDateTime: string;
    targetCount: number;
    sentCount: number;
    readCount: number;
    clickCount: number;
    createdAt: string;
    creatorName: string;
    creatorAuthorizationType: string;
    modifiedAt?: string;
    modifierName?: string;
    modifierAuthorizationType?: string;
    content: {
      text?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
      };
      image?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      wideImage?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      carousel?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        title: string;
        text: string;
        imageUrl: string;
        imageLink?: string;
      }[];
    };
    estimatedPointsUsed: number;
    actualPointsUsed: number;
    unitPrice: number;
  };
  message: string;
}

export interface AlgorithmControllerFindConsultationMessageStatsResponse {
  code: number;
  data: {
    algorithmName: string;
    messageName: string;
    daysAfter: number;
    sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "BRAND_MESSAGE";
    contentType:
      | "TEXT"
      | "IMAGE"
      | "VIDEO"
      | "WORKOUT_VIDEO"
      | "HOMECARE_CONTENT"
      | "EVENT"
      | "SURVEY"
      | "WIDE_IMAGE"
      | "CAROUSEL";
    targetCount: number;
    successCount: number;
    usedCredit?: number;
    unitPrice?: number;
    lastModified: {
      at: string;
      by: {
        name: string;
        role: string;
      };
    };
    created: {
      at: string;
      by: {
        name: string;
        role: string;
      };
    };
  };
  message: string;
}

export interface AlgorithmControllerFindConsultationMessageSendHistoriesResponse {
  code: number;
  data: {
    totalCount: number;
    histories: {
      patientID: string;
      sendAt: string;
      name: string;
      phone: string;
      internationalDialingCodes: string;
      status: "WAIT" | "COMPLETE" | "FAIL";
      failedReason?: string;
    }[];
  };
  message: string;
}

export interface AlgorithmControllerFindAlgorithmMessageSendHistoriesResponse {
  code: number;
  data: {
    totalCount: number;
    histories: {
      patientID: string;
      sendAt: string;
      name: string;
      phone: string;
      internationalDialingCodes: string;
      status: "WAITING" | "REQUESTED" | "SUCCEEDED" | "FAILED";
      failedReason?: string;
    }[];
  };
  message: string;
}

export interface AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelResponse {
  code: number;
  data: {
    /** presigned 다운로드 URL */
    url: string;
    /** 브라우저가 저장할 파일명 */
    fileName: string;
    /** URL 만료 시각(ISO) */
    expiresAt: string;
  };
  message: string;
}

export interface AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelResponse {
  code: number;
  data: {
    /** presigned 다운로드 URL */
    url: string;
    /** 브라우저가 저장할 파일명 */
    fileName: string;
    /** URL 만료 시각(ISO) */
    expiresAt: string;
  };
  message: string;
}

export interface AlgorithmControllerFindTopAlgorithmMessagesResponse {
  code: number;
  data: {
    _id: string;
    name: string;
    algorithmID: string;
    algorithmName: string;
    sendingDateTime: string;
    targetCount: number;
    sentCount: number;
    readCount: number;
    clickCount: number;
    createdAt: string;
    creatorName: string;
    creatorAuthorizationType: string;
    modifiedAt?: string;
    modifierName?: string;
    modifierAuthorizationType?: string;
    content: {
      text?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
      };
      image?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      wideImage?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        text: string;
        imageUrl: string;
        imageLink?: string;
      };
      carousel?: {
        buttons: {
          name: string;
          webLink?: {
            urlMobile: string;
            urlPc?: string;
          };
          bizForm?: {
            bizFormKey: string;
            bizFormId?: string;
          };
          appLink?: {
            schemeIos?: string;
            schemeAndroid?: string;
            urlMobile?: string;
            urlPc?: string;
          };
          messageDelivery?: Record<string, any>;
        }[];
        coupon?: {
          type:
            | "DISCOUNT_BY_PRICE"
            | "DISCOUNT_BY_PERCENT"
            | "DISCOUNT_DELIVERY"
            | "PRODUCT_FREE"
            | "PRODUCT_PROMOTION";
          /** 쿠폰 상세 설명 */
          description: string;
          urlMobile: string;
          urlPc?: string;
          variable?: string;
          schemeAndroid?: string;
          schemeIos?: string;
        };
        title: string;
        text: string;
        imageUrl: string;
        imageLink?: string;
      }[];
    };
    estimatedPointsUsed: number;
    actualPointsUsed: number;
    unitPrice: number;
  }[];
  message: string;
}

export interface AlgorithmControllerFindSelectableNationalitiesResponse {
  code: number;
  data: {
    noNationality: boolean;
    nationalities: {
      _id: string;
      koreanCountryName: string;
      englishCountryName: string;
    }[];
  };
  message: string;
}

export interface AlgorithmControllerFindAlgorithmMessagesResponse {
  code: number;
  data: {
    totalCount: number;
    messages: {
      _id: string;
      name: string;
      algorithmID: string;
      algorithmName: string;
      sendingDateTime: string;
      targetCount: number;
      sentCount: number;
      readCount: number;
      clickCount: number;
      createdAt: string;
      creatorName: string;
      creatorAuthorizationType: string;
      modifiedAt?: string;
      modifierName?: string;
      modifierAuthorizationType?: string;
    }[];
  };
  message: string;
}

export interface AlgorithmControllerFindStatisticsResponse {
  code: number;
  data: {
    totalMessageCount: number;
    remainingPoints: number;
  };
  message: string;
}

export interface AlgorithmControllerFindOngoingAutomationsResponse {
  code: number;
  data: {
    algorithmId: string;
    algorithmName: string;
    appliedNationalityNames: string[];
    tagsHaveNoFolder: {
      tagId: string;
      tagName: string;
    }[];
    tagsHaveFolder: {
      folderID: string;
      folderName: string;
      tags: {
        tagId: string;
        tagName: string;
      }[];
    }[];
    appliedTagNames: string[];
  }[];
  message: string;
}

export interface AlgorithmControllerFindPatientMessageHistoriesResponse {
  code: number;
  data: {
    items: {
      /** 원본 도큐먼트 식별자 */
      _id: string;
      /** 상담자동화 / 재진마케팅 / 치료태그 주의사항 구분 */
      kind: "consultation" | "revisitMarketing" | "treatmentCaution";
      /** 발송(예정) 일시 ISO 문자열 */
      sendDateTime: string;
      /** 알고리즘 이름 */
      algorithmName: string;
      /** 미리보기 단건 조회용 AlgorithmMessage._id (kind 무관) */
      algorithmMessageID: string;
      /** 상담자동화 D+N 표시용 일수. consultation 인 경우에만 의미 있음 */
      daysAfter?: number;
      /** 대기 / 성공 / 실패 */
      status: "WAIT" | "COMPLETE" | "FAIL";
      /** 메시지가 발송된 채널 (알림톡 / 애프터닥 앱 / 브랜드 메시지) */
      messageChannel: "ALIMTALK" | "AFTERDOC_APP" | "BRAND_MESSAGE";
      /** 실패 사유. status=FAIL 인 경우에만 의미 있음 */
      failReason?: string;
      /** 메시지 이름. 다이얼로그 헤더 표시 */
      name: string;
      /** 메시지 컨텐츠 타입(이벤트 포함 라벨용) */
      contentType: string | null;
      /** 발송 타입(상담자동화 미리보기 표시용) */
      sendingType: string | null;
      /** 상담 가이드 노출 여부 */
      showConsultationGuide: boolean;
      /** 상담 가이드 본문 */
      consultationGuide: string | null;
      /** 치환된 본문과 첨부 */
      content: {
        /** 환자별 변수 치환된 본문. 첨부만 있는 메시지는 빈 문자열 */
        text: string;
        /** 이미지 URL 배열. 없으면 빈 배열 */
        images: string[];
        /** 비디오 URL. 없으면 null */
        video: string | null;
        survey: {
          question: string | null;
          answers: string[] | null;
        };
        /** 브랜드메시지 본문 객체. 브랜드메시지가 아니면 null. 외부 키 형태(carousel) 사용. */
        brandMessageContent: {
          text?: {
            buttons: {
              name: string;
              webLink?: {
                urlMobile: string;
                urlPc?: string;
              };
              bizForm?: {
                bizFormKey: string;
                bizFormId?: string;
              };
              appLink?: {
                schemeIos?: string;
                schemeAndroid?: string;
                urlMobile?: string;
                urlPc?: string;
              };
              messageDelivery?: Record<string, any>;
            }[];
            coupon?: {
              type:
                | "DISCOUNT_BY_PRICE"
                | "DISCOUNT_BY_PERCENT"
                | "DISCOUNT_DELIVERY"
                | "PRODUCT_FREE"
                | "PRODUCT_PROMOTION";
              /** 쿠폰 상세 설명 */
              description: string;
              urlMobile: string;
              urlPc?: string;
              variable?: string;
              schemeAndroid?: string;
              schemeIos?: string;
            };
            text: string;
          };
          image?: {
            buttons: {
              name: string;
              webLink?: {
                urlMobile: string;
                urlPc?: string;
              };
              bizForm?: {
                bizFormKey: string;
                bizFormId?: string;
              };
              appLink?: {
                schemeIos?: string;
                schemeAndroid?: string;
                urlMobile?: string;
                urlPc?: string;
              };
              messageDelivery?: Record<string, any>;
            }[];
            coupon?: {
              type:
                | "DISCOUNT_BY_PRICE"
                | "DISCOUNT_BY_PERCENT"
                | "DISCOUNT_DELIVERY"
                | "PRODUCT_FREE"
                | "PRODUCT_PROMOTION";
              /** 쿠폰 상세 설명 */
              description: string;
              urlMobile: string;
              urlPc?: string;
              variable?: string;
              schemeAndroid?: string;
              schemeIos?: string;
            };
            text: string;
            imageUrl: string;
            imageLink?: string;
          };
          wideImage?: {
            buttons: {
              name: string;
              webLink?: {
                urlMobile: string;
                urlPc?: string;
              };
              bizForm?: {
                bizFormKey: string;
                bizFormId?: string;
              };
              appLink?: {
                schemeIos?: string;
                schemeAndroid?: string;
                urlMobile?: string;
                urlPc?: string;
              };
              messageDelivery?: Record<string, any>;
            }[];
            coupon?: {
              type:
                | "DISCOUNT_BY_PRICE"
                | "DISCOUNT_BY_PERCENT"
                | "DISCOUNT_DELIVERY"
                | "PRODUCT_FREE"
                | "PRODUCT_PROMOTION";
              /** 쿠폰 상세 설명 */
              description: string;
              urlMobile: string;
              urlPc?: string;
              variable?: string;
              schemeAndroid?: string;
              schemeIos?: string;
            };
            text: string;
            imageUrl: string;
            imageLink?: string;
          };
          carousel?: {
            buttons: {
              name: string;
              webLink?: {
                urlMobile: string;
                urlPc?: string;
              };
              bizForm?: {
                bizFormKey: string;
                bizFormId?: string;
              };
              appLink?: {
                schemeIos?: string;
                schemeAndroid?: string;
                urlMobile?: string;
                urlPc?: string;
              };
              messageDelivery?: Record<string, any>;
            }[];
            coupon?: {
              type:
                | "DISCOUNT_BY_PRICE"
                | "DISCOUNT_BY_PERCENT"
                | "DISCOUNT_DELIVERY"
                | "PRODUCT_FREE"
                | "PRODUCT_PROMOTION";
              /** 쿠폰 상세 설명 */
              description: string;
              urlMobile: string;
              urlPc?: string;
              variable?: string;
              schemeAndroid?: string;
              schemeIos?: string;
            };
            title: string;
            text: string;
            imageUrl: string;
            imageLink?: string;
          }[];
        } | null;
      };
    }[];
    totalCount: number;
  };
  message: string;
}

export interface AlgorithmControllerBackfillConsultationSentCountResponse {
  code: number;
  data: {
    updated: number;
  };
  message: string;
}

export interface TargetableNationalitiesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 한국어 국가명 */
    koreanCountryName: string;
    /** 국제 전화 코드 */
    internationalDialingCodes: string;
    /** ISO 3166-1 alpha-2 국가 코드 */
    countryCodeISOAlpha2: string;
    /** ISO 3166-1 alpha-3 국가 코드 */
    countryCodeISOAlpha3: string;
    /** 영어 국가명 */
    englishCountryName: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SingleAlgorithmMessageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 메시지 이름 */
    name: string;
    /** 메시지의 유형 - 기본(BASIC), 재내원유도 필수 메시지(REVISIT_INDUCEMENT), 설문(SURVEY), 브랜드 메시지(BRAND_MESSAGE) */
    sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "BRAND_MESSAGE";
    /**
     * 메시지 전송 날짜 (ISO 8601 형식)
     * @format date
     */
    sendingDateTime?: string;
    /** 메시지 내용 */
    content: {
      /** 메시지 텍스트 */
      text?: string;
      /** 이미지 URL 배열 */
      images?: string[];
      /** 비디오 URL */
      video?: string;
      homeCare?: {
        /** 홈케어 제목 */
        title: string;
        /** 홈케어 설명 */
        description: string;
        /** 홈케어 기간 */
        duration: string;
      };
      event?: {
        /** 이벤트 제목 */
        title: string;
        /** 이벤트 설명 */
        description: string;
        /** 이벤트 가격 */
        price: number;
        /** 이벤트 할인 가격 */
        discountPrice: number;
      };
      survey?: {
        /** 설문조사 질문 */
        question: string;
        /** 설문조사 옵션 배열 */
        answers: string[];
      };
    };
    /** 상담 가이드 표시 여부 */
    showConsultationGuide: boolean;
    /** 상담 가이드 내용 */
    consultationGuide?: string;
    /** 응답 여부와 상관없이 전송 여부 */
    sendRegardlessOfResponse?: boolean;
    /** sendingType 이 BRAND_MESSAGE 인 경우 페어링된 KakaoBrandMessageTemplate 의 본문/타깃팅 */
    brandMessage?: {
      /** Infobank 브랜드 메시지 본문 */
      content: {
        text?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
        };
        image?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        wideImage?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        carousel?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          title: string;
          text: string;
          imageUrl: string;
          imageLink?: string;
        }[];
      };
      /** 브랜드 메시지 타깃팅 */
      targeting?: "M" | "N" | "I";
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SingleAlgorithmHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 알고리즘 ID */
    _id: string;
    /** 알고리즘 이름 */
    name: string;
    /** 전송 일정 정보 */
    sendingSchedule?: {
      /**
       * 시작 날짜
       * @format date
       */
      startDay?: string;
      /** 전송 횟수 */
      sendingCount?: number;
    };
    /** 적용된 치료 태그 ID 배열 */
    appliedTreatmentTagIds?: string[];
    /** 적용된 국적 ID 배열 */
    appliedNationalityIds?: string[];
    /** 치료 태그 없음을 선택하는 경우 - 마케팅 자동화 생성에만 해당 */
    isForNoTreatmentTags?: boolean;
    /** 국적 없음을 선택하는 경우 - 마케팅 자동화 생성에만 해당 */
    isForNoNationality?: boolean;
    /** 적용된 국적 정보 */
    appliedNationalities: {
      /** MongoDB Identifier */
      _id: string;
      /** 한국어 국가명 */
      koreanCountryName: string;
      /** 국제 전화 코드 */
      internationalDialingCodes: string;
      /** ISO 3166-1 alpha-2 국가 코드 */
      countryCodeISOAlpha2: string;
      /** ISO 3166-1 alpha-3 국가 코드 */
      countryCodeISOAlpha3: string;
      /** 영어 국가명 */
      englishCountryName: string;
    }[];
    /** 자동화 적용 대상 환자 수 */
    targetCount?: number;
    /** 자동화 메시지 조회 환자 수 - 누적 */
    readCount?: number;
    /** 자동화 메시지에 대한 응답 환자 수 */
    responseCount?: number;
    /** 폴더 정보와 하위 치료 태그들 정보 */
    tagsHaveFolder: {
      /** 폴더 ID */
      _id: string;
      /** 폴더 이름 */
      name: string;
      /** 폴더 내 태그 정보 */
      tags: {
        /** 치료 태그 ID */
        _id: string;
        /** 치료 태그 이름 */
        categoryName: string;
        /** 태그 색상 */
        color: string;
      }[];
    }[];
    /** 폴더를 가지지 않는 치료 태그 정보 */
    tagsHaveNoFolder: {
      /** 치료 태그 ID */
      _id: string;
      /** 치료 태그 이름 */
      categoryName: string;
      /** 태그 색상 */
      color: string;
    }[];
    /**
     * 마지막 수정 일시
     * @format date
     */
    modifiedAt?: string;
    /** 마지막 수정자 이름 */
    modifierName?: string;
    /** 마지막 수정자 직무 */
    modifierJobType?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SubmittingSurveyResponseHandlerBodyRequest {
  /**
   * 채팅 ID
   * @example "6721ef165c36ac6bad7b820c"
   */
  chatID: string;
  /**
   * 설문 메시지 ID
   * @example "66c30cb57ae0c769d784db71"
   */
  messageId: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 환자 ID
   * @example "66ceb65989b82a24ee87a3be"
   */
  patientID: string;
  /**
   * 설문에 대한 답변 인덱스
   * @example 3
   */
  answerIndex: number;
}

export interface SubmittingSurveyResponseHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    chatRoomID: string;
    type: number;
    content?: string;
    translatedContent?: string;
    retranslatedContent?: string;
    isTranslated?: boolean;
    userType: number;
    userID: string;
    fileIDs: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    }[];
    videoContentIDs: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      subtitle: string;
      caregoryName?: string[];
      searchKeyword?: string[];
      exerciseType: string;
      stimulateMuscles?: string;
      stimulateMusclesImageID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      description: string;
      relatedDiseases: string;
      exerciseSet?: {
        title: string;
        titleEn: string;
        description: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        timestamp: number;
      }[];
      meterial?: {
        name: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
      };
      precaution: string;
      doPerWeek: number;
      duration: number;
      endDate?: number;
      message?: string;
      thumbnailFileID: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      videoFileID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      isDetail: boolean;
      isHidden: boolean;
      isRemoved: boolean;
      isRecommend: boolean;
      isRead: boolean;
      totalVideoLength: number;
      viewCount?: number;
    }[];
    heventID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    haftercareID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    hnoticeID?: {
      /** MongoDB Identifier */
      _id: string;
      index?: number;
      title: string;
      content: string;
      viewCount?: number;
      isRemoved?: boolean;
      hospitalID?: string;
      writerID?: string;
      modifierID?: string;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    /** 알고리즘 메시지 ID */
    algorithmMessageId?: string;
    /** 설문 응답 ID */
    surveyResponseId?: string;
    /** 치료태그 자동 발송으로 만들어진 채팅 메시지일 경우 발송 트리거 치료태그 ID. 수동 채팅 및 다른 자동화에는 채워지지 않는다. */
    treatmentCautionTagID?: string;
    isBookmark?: boolean;
    /** @format date */
    bookmarkedAt?: string;
    tempID?: string;
    markers: string[];
    userName?: string;
    jobType?: string;
    userRealName?: string;
    photoPath?: string;
    caName?: string;
    caCycle?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    sentAt?: string;
    /**
     * fileIDs 가 존재할 경우 하위에 담겨있는 URL 목록
     * @example ["https://example.com/image.jpg"]
     */
    fileUrls?: string[];
    /** @example {"question":"설문 질문","answers":["설문 답변 1","설문 답변 2"]} */
    survey?: {
      /**
       * 설문 질문
       * @example "설문 질문"
       */
      question?: string;
      /**
       * 설문 답변 목록
       * @example ["설문 답변 1","설문 답변 2"]
       */
      answers?: string[];
      /**
       * 설문 답변 인덱스
       * @example 2
       */
      surveyAnswerIndex?: number;
      /**
       * 설문 답변 인덱스에 해당하는 값
       * @example "매우 만족"
       */
      surveyAnswerValue?: string;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface GeneratingSurveyHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "613d614a25276223a9b1eea8"
   */
  hospitalID: string;
  /**
   * 환자 ID
   * @example "66950a225e97127318cb7880"
   */
  patientID: string;
}

export interface GeneratingSurveyHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    chatRoomID: string;
    type: number;
    content?: string;
    translatedContent?: string;
    retranslatedContent?: string;
    isTranslated?: boolean;
    userType: number;
    userID: string;
    fileIDs: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    }[];
    videoContentIDs: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      subtitle: string;
      caregoryName?: string[];
      searchKeyword?: string[];
      exerciseType: string;
      stimulateMuscles?: string;
      stimulateMusclesImageID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      description: string;
      relatedDiseases: string;
      exerciseSet?: {
        title: string;
        titleEn: string;
        description: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        timestamp: number;
      }[];
      meterial?: {
        name: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
      };
      precaution: string;
      doPerWeek: number;
      duration: number;
      endDate?: number;
      message?: string;
      thumbnailFileID: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      videoFileID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      isDetail: boolean;
      isHidden: boolean;
      isRemoved: boolean;
      isRecommend: boolean;
      isRead: boolean;
      totalVideoLength: number;
      viewCount?: number;
    }[];
    heventID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    haftercareID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    hnoticeID?: {
      /** MongoDB Identifier */
      _id: string;
      index?: number;
      title: string;
      content: string;
      viewCount?: number;
      isRemoved?: boolean;
      hospitalID?: string;
      writerID?: string;
      modifierID?: string;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    /** 알고리즘 메시지 ID */
    algorithmMessageId?: string;
    /** 설문 응답 ID */
    surveyResponseId?: string;
    /** 치료태그 자동 발송으로 만들어진 채팅 메시지일 경우 발송 트리거 치료태그 ID. 수동 채팅 및 다른 자동화에는 채워지지 않는다. */
    treatmentCautionTagID?: string;
    isBookmark?: boolean;
    /** @format date */
    bookmarkedAt?: string;
    tempID?: string;
    markers: string[];
    userName?: string;
    jobType?: string;
    userRealName?: string;
    photoPath?: string;
    caName?: string;
    caCycle?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    sentAt?: string;
    /**
     * fileIDs 가 존재할 경우 하위에 담겨있는 URL 목록
     * @example ["https://example.com/image.jpg"]
     */
    fileUrls?: string[];
    /** @example {"question":"설문 질문","answers":["설문 답변 1","설문 답변 2"]} */
    survey?: {
      /**
       * 설문 질문
       * @example "설문 질문"
       */
      question?: string;
      /**
       * 설문 답변 목록
       * @example ["설문 답변 1","설문 답변 2"]
       */
      answers?: string[];
      /**
       * 설문 답변 인덱스
       * @example 2
       */
      surveyAnswerIndex?: number;
      /**
       * 설문 답변 인덱스에 해당하는 값
       * @example "매우 만족"
       */
      surveyAnswerValue?: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UpdateAlgorithmMainDataHandlerBodyRequest {
  /**
   * 수정할 알고리즘 ID
   * @example "672d90a34afa7c09f865a862"
   */
  algorithmId: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 수정할 알고리즘 이름
   * @example "알고리즘 이름"
   */
  name: string;
  /**
   * 수정할 대상 치료태그 ID 목록 - 상담 자동화 in-place 편집용
   * @example ["66ac5bae07a37e99d4ae628d"]
   */
  targetTreatmentTags?: string[];
  /**
   * 수정할 적용 국적 ID 목록 (빈 배열이면 전체 국적) - 상담 자동화 in-place 편집용
   * @example ["673fe35534a41b413fdd3164"]
   */
  appliedNationalities?: string[];
  /** 발송 스케줄 - 마케팅 자동화인 경우만 사용 */
  sendingSchedule?: {
    /**
     * 시작일
     * @format date
     * @example "2022-01-01"
     */
    startDay: string;
    /**
     * 발송 횟수
     * @example 3
     */
    sendingCount: number;
  };
  /** 공통 알고리즘 데이터 - 상담 자동화인 경우만 사용 (deprecated: MDP-1236) */
  commonAlgorithm?: {
    /**
     * 공통 알고리즘 사용 여부
     * @example true
     */
    enabled: boolean;
    /**
     * 공통 알고리즘 메시지 발송을 자동화 설정 이후 며칠 뒤에 할 건지에 대한 값
     * @example 3
     */
    sendingDaysAfterStart: number;
  };
}

export interface UpdateAlgorithmMainDataHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 자동화 메인 정보 수정 성공 여부 */
    isUpdatedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface QAAutomationSendTriggerHandlerBodyRequest {
  /**
   * 발송할 대상의 병원 ID
   * @example ""
   */
  hospitalID?: string;
  /**
   * 발송할 대상의 HService ID
   * @example ""
   */
  hserviceID?: string;
  /**
   * ex : 2025-05-01 09:00
   * @format date
   * @example "2025-05-01 09:00"
   */
  date?: string;
}

export interface QAAutomationSendTriggerHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isSuccess?: boolean;
    failed?: {
      reservedMessageID?: string;
      err?: any;
      /** @format date */
      failedAt?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface QAAutomationAppliedListHandlerBodyRequest {
  /** HService 의 _id */
  hserviceID?: string;
  /** 조회하고자 하는 자동화 상태값. 값이 없다면 모든 상태를 조회 */
  status?: "PROGRESS" | "PAUSE" | "STOP" | "COMPLETE";
}

export interface QAAutomationAppliedListHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hserviceID?: string;
    hospitalID?: string;
    algorithmID?: string;
    algorithmType: {
      _id?: string;
      name?: string;
      type?: string;
    };
    treatmentcategoryID: {
      _id?: string;
      categoryName?: string;
      customColor?: string;
    };
    countryID: {
      _id?: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
      countryCodeISOAlpha2?: string;
    };
    status?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    startedAt?: string;
    /** @format date */
    terminatedAt?: string;
    terminateReason?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface QAAutomationReservedMessageListHandlerBodyRequest {
  /** HService 의 _id */
  hserviceID?: string;
  /**
   * 조회하고자 하는 메세지 상태값. 값이 없다면 모든 상태를 조회
   * @example "WAIT"
   */
  status?: "WAIT" | "CANCEL" | "COMPLETE" | "FAIL";
}

export interface QAAutomationReservedMessageListHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hserviceID?: string;
    hospitalID?: string;
    algorithmID?: string;
    algorithmType?: string;
    treatmentcategoryID?: string;
    status?: string;
    /** @format date */
    createdAt?: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    startedAt?: string;
    /** @format date */
    terminatedAt?: string;
    terminateReason?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiAutomationsElOngoingParams {
  /** 병원 ID */
  hospitalID: string;
}

export type ApiAutomationsElOngoingData = OngoingAutomationResponse;

export type ApiAutomationsElAlgorithmsSingleData = ApiResponse & {
  data: AlgorithmCreationResponse;
};

export interface AlgorithmControllerDeleteAlgorithmParams {
  algorithmID: string;
}

export type AlgorithmControllerDeleteAlgorithmData = AlgorithmControllerDeleteAlgorithmResponse;

export type ApiAutomationsElAlgorithmsSingleDeletionData = ApiResponse & {
  data: {
    /** 알고리즘 삭제 성공 여부 */
    isDeleted: boolean;
  };
};

export interface ApiAutomationsElMainListParams {
  /** 병원 ID */
  hospitalID: string;
  /** 알고리즘 이름으로 검색하기 위한 필터 - like 검색이며 단어 하나만 지원합니다. */
  algorithmNameFilter?: string;
  /** 치료 태그 이름으로 검색하기 위한 필터 - like 검색이며 단어 하나만 지원합니다. */
  treatmentTagNameFilter?: string;
  /** 국적 이름으로 검색하기 위한 필터 - like 검색이며 단어 하나만 지원합니다. */
  nationalityNameFilter?: string;
}

export type ApiAutomationsElMainListData = ApiResponse & {
  data: AutomationMain;
};

export interface ApiAutomationsElDashboardParams {
  /** 병원 ID */
  hospitalID: string;
  /** 조회 연도 */
  year: number;
  /** 조회 월 */
  month: number;
  /** 조회 주차 */
  week: number;
}

export type ApiAutomationsElDashboardData = ApiResponse & {
  data: Dashboard;
};

export interface ApiAutomationsElAlgorithmsMessagesParams {
  /**
   * 알고리즘 ID
   * @example "67161b4d5c735f0b502e03bb"
   */
  algorithmId: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type ApiAutomationsElAlgorithmsMessagesData = ApiResponse & {
  data: AlgorithmMessage[];
};

export type ApiAutomationsElAlgorithmsMessagesSingleData = ApiResponse & {
  data: {
    /** 메시지 추가 성공 여부 */
    isCreatedSuccess: boolean;
    /** 새로 생성된 메시지 ID */
    newMessageId: string;
  };
};

export type ApiAutomationsElAlgorithmsMessagesUpsertSingleData = ApiResponse & {
  data: {
    /** 메시지 수정 성공 여부 */
    isUpdated: boolean;
  };
};

export type ApiAutomationsElAlgorithmsMessagesDeleteSingleData = ApiResponse & {
  data: {
    /** 메시지 삭제 성공 여부 */
    isDeleted: boolean;
  };
};

export type ApiAutomationsElAlgorithmsToggleData = ApiResponse & {
  data: {
    /** 알고리즘 상태 변경 성공 여부 */
    isToggled: boolean;
    /** 현재 알고리즘 활성화 상태 */
    currentStatus: boolean;
  };
};

export interface ApiAutomationsElAlgorithmsResponsesParams {
  /** 메시지 ID */
  messageId: string;
}

export type ApiAutomationsElAlgorithmsResponsesData = ApiResponse & {
  data: MessageResponse[];
};

export interface ApiAutomationsElAffectedPatientCountWhenTreatmentTagDeletedParams {
  /** 치료 태그 ID */
  treatmentTagId: string;
  /** 병원 ID */
  hospitalID: string;
}

export type ApiAutomationsElAffectedPatientCountWhenTreatmentTagDeletedData = ApiResponse & {
  data: AffectedPatientCount;
};

export type KakaoTemplateRenewingControllerRenewTemplateStatusesData =
  KakaoTemplateRenewingControllerRenewTemplateStatusesResponse;

export interface AlgorithmControllerGetMarkingTargetCountParams {
  /** @default false */
  isForNoTreatmentTags?: boolean | null;
  treatmentTagIds?: string;
  /** @default false */
  isForNoNationality?: boolean | null;
  nationalityIds?: string;
}

export type AlgorithmControllerGetMarkingTargetCountData = AlgorithmControllerGetMarkingTargetCountResponse;

export type AlgorithmControllerGetMarketingAlgorithmTargetCountData =
  AlgorithmControllerGetMarketingAlgorithmTargetCountResponse;

export type AlgorithmControllerFindMarketingAlgorithmsData = AlgorithmControllerFindMarketingAlgorithmsResponse;

export type AlgorithmControllerCreateMarketingAlgorithmData = AlgorithmControllerCreateMarketingAlgorithmResponse;

export type AlgorithmControllerUpdateMarketingAlgorithmData = AlgorithmControllerUpdateMarketingAlgorithmResponse;

export interface AlgorithmControllerFindMarketingAlgorithmParams {
  _id: string;
}

export type AlgorithmControllerFindMarketingAlgorithmData = AlgorithmControllerFindMarketingAlgorithmResponse;

export interface AlgorithmControllerFindAlgorithmMessageParams {
  _id: string;
  hserviceID?: string;
}

export type AlgorithmControllerFindAlgorithmMessageData = AlgorithmControllerFindAlgorithmMessageResponse;

export interface AlgorithmControllerFindConsultationMessageStatsParams {
  /** @minLength 1 */
  _id: string;
}

export type AlgorithmControllerFindConsultationMessageStatsData =
  AlgorithmControllerFindConsultationMessageStatsResponse;

export interface AlgorithmControllerFindConsultationMessageSendHistoriesParams {
  /** @minLength 1 */
  _id: string;
  skip?: number | null;
  limit?: number | null;
  searchText?: string;
}

export type AlgorithmControllerFindConsultationMessageSendHistoriesData =
  AlgorithmControllerFindConsultationMessageSendHistoriesResponse;

export interface AlgorithmControllerFindAlgorithmMessageSendHistoriesParams {
  _id: string;
  skip?: number | null;
  limit?: number | null;
  searchText?: string;
}

export type AlgorithmControllerFindAlgorithmMessageSendHistoriesData =
  AlgorithmControllerFindAlgorithmMessageSendHistoriesResponse;

export interface AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelParams {
  _id: string;
}

export type AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelData =
  AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelResponse;

export interface AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelParams {
  _id: string;
}

export type AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelData =
  AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelResponse;

export interface AlgorithmControllerFindTopAlgorithmMessagesParams {
  limit?: number | null;
}

export type AlgorithmControllerFindTopAlgorithmMessagesData = AlgorithmControllerFindTopAlgorithmMessagesResponse;

export type AlgorithmControllerFindSelectableNationalitiesData = AlgorithmControllerFindSelectableNationalitiesResponse;

export interface AlgorithmControllerFindAlgorithmMessagesParams {
  limit?: number | null;
  skip?: number | null;
}

export type AlgorithmControllerFindAlgorithmMessagesData = AlgorithmControllerFindAlgorithmMessagesResponse;

export type AlgorithmControllerFindStatisticsData = AlgorithmControllerFindStatisticsResponse;

export type AlgorithmControllerFindOngoingAutomationsData = AlgorithmControllerFindOngoingAutomationsResponse;

export interface AlgorithmControllerFindPatientMessageHistoriesParams {
  hserviceID: string;
  /** YYYY-MM-DD */
  startDate: string;
  /** YYYY-MM-DD */
  endDate: string;
  /** @default 10 */
  limit?: number | null;
  /** @default 0 */
  offset?: number | null;
}

export type AlgorithmControllerFindPatientMessageHistoriesData = AlgorithmControllerFindPatientMessageHistoriesResponse;

export interface AlgorithmControllerBackfillConsultationSentCountParams {
  until?: string;
}

export type AlgorithmControllerBackfillConsultationSentCountData =
  AlgorithmControllerBackfillConsultationSentCountResponse;

export interface TargetableNationalitiesHandlerParams {
  /**
   * 치료 태그 ID
   * @example "66ac5bae07a37e99d4ae628d"
   */
  treatmentTagId?: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 예외 처리할 알고리즘 ID
   * @example "673fe35534a41b413fdd3164"
   */
  exceptionTargetAlgorithmId?: string;
}

export type TargetableNationalitiesHandlerData = TargetableNationalitiesHandlerResponse;

export interface SingleAlgorithmMessageHandlerParams {
  /**
   * 알고리즘 메시지 ID
   * @example "66c30cb57ae0c769d784db71"
   */
  messageId: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type SingleAlgorithmMessageHandlerData = SingleAlgorithmMessageHandlerResponse;

export interface SingleAlgorithmHandlerParams {
  /**
   * 알고리즘 ID
   * @example "66ac86ce07a37e99d4ae62c8"
   */
  algorithmId: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type SingleAlgorithmHandlerData = SingleAlgorithmHandlerResponse;

export type SubmittingSurveyResponseHandlerData = SubmittingSurveyResponseHandlerResponse;

export type GeneratingSurveyHandlerData = GeneratingSurveyHandlerResponse;

export type UpdateAlgorithmMainDataHandlerData = UpdateAlgorithmMainDataHandlerResponse;

export type RenewingKakaoTemplateStatusBatchHandlerData = any;

export type QaAutomationSendTriggerHandlerData = QAAutomationSendTriggerHandlerResponse;

export type QaAutomationAppliedListHandlerData = QAAutomationAppliedListHandlerResponse;

export type QaAutomationReservedMessageListHandlerData = QAAutomationReservedMessageListHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 특정 병원의 진행 중인 상담 자동화 목록을 조회합니다. -> GET /v3/api/automations/ongoing로 대체되었습니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElOngoing
     * @summary 진행 중인 상담 자동화 목록 조회 API -> GET /v3/api/automations/ongoing로 대체되었습니다.
     * @request GET:/v3/api/automations/el/ongoing
     * @deprecated
     * @secure
     * @response `200` `ApiAutomationsElOngoingData` 진행 중인 자동화 목록 조회 성공
     */
    apiAutomationsElOngoing: (query: ApiAutomationsElOngoingParams, params: RequestParams = {}) =>
      this.request<ApiAutomationsElOngoingData, any>({
        path: `/v3/api/automations/el/ongoing`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 새로운 알고리즘과 관련 메시지를 생성합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsSingle
     * @summary 알고리즘 및 메시지 생성
     * @request POST:/v3/api/automations/el/algorithms/single
     * @secure
     * @response `201` `ApiAutomationsElAlgorithmsSingleData` 알고리즘 및 메시지 생성 성공
     */
    apiAutomationsElAlgorithmsSingle: (data: AlgorithmWithMessagesInput, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsSingleData, any>({
        path: `/v3/api/automations/el/algorithms/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 알고리즘을 삭제합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerDeleteAlgorithm
     * @summary 알고리즘 삭제
     * @request DELETE:/v3/api/automations/el/algorithms/single
     * @secure
     * @response `200` `AlgorithmControllerDeleteAlgorithmData` success
     */
    algorithmControllerDeleteAlgorithm: (query: AlgorithmControllerDeleteAlgorithmParams, params: RequestParams = {}) =>
      this.request<AlgorithmControllerDeleteAlgorithmData, any>({
        path: `/v3/api/automations/el/algorithms/single`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘을 삭제합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsSingleDeletion
     * @summary 단일 알고리즘 삭제
     * @request POST:/v3/api/automations/el/algorithms/single-deletion
     * @secure
     * @response `200` `ApiAutomationsElAlgorithmsSingleDeletionData` 알고리즘 삭제 성공
     */
    apiAutomationsElAlgorithmsSingleDeletion: (data: AlgorithmDeletionRequest, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsSingleDeletionData, any>({
        path: `/v3/api/automations/el/algorithms/single-deletion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 자동화 서비스의 메인 정보를 조회합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElMainList
     * @summary 자동화 서비스 메인 조회
     * @request GET:/v3/api/automations/el/main-list
     * @secure
     * @response `200` `ApiAutomationsElMainListData` 성공적으로 자동화 서비스 메인 정보 조회
     */
    apiAutomationsElMainList: (query: ApiAutomationsElMainListParams, params: RequestParams = {}) =>
      this.request<ApiAutomationsElMainListData, any>({
        path: `/v3/api/automations/el/main-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 자동화 서비스의 대시보드 정보를 조회합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElDashboard
     * @summary 자동화 대시보드 조회
     * @request GET:/v3/api/automations/el/dashboard
     * @secure
     * @response `200` `ApiAutomationsElDashboardData` 성공적으로 대시보드 정보 조회
     */
    apiAutomationsElDashboard: (query: ApiAutomationsElDashboardParams, params: RequestParams = {}) =>
      this.request<ApiAutomationsElDashboardData, any>({
        path: `/v3/api/automations/el/dashboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘에 속한 메시지 목록을 조회합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsMessages
     * @summary 알고리즘의 메시지 목록 조회
     * @request GET:/v3/api/automations/el/algorithms/messages
     * @secure
     * @response `200` `ApiAutomationsElAlgorithmsMessagesData` 성공적으로 메시지 목록 조회
     */
    apiAutomationsElAlgorithmsMessages: (query: ApiAutomationsElAlgorithmsMessagesParams, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsMessagesData, any>({
        path: `/v3/api/automations/el/algorithms/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘에 새로운 메시지를 추가합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsMessagesSingle
     * @summary 알고리즘에 새 메시지 추가
     * @request POST:/v3/api/automations/el/algorithms/messages/single
     * @secure
     * @response `201` `ApiAutomationsElAlgorithmsMessagesSingleData` 메시지 추가 성공
     * @response `400` `ApiResponse` 잘못된 요청
     * @response `404` `ApiResponse` 알고리즘을 찾을 수 없음
     */
    apiAutomationsElAlgorithmsMessagesSingle: (data: NewMessageInput, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsMessagesSingleData, ApiResponse>({
        path: `/v3/api/automations/el/algorithms/messages/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘의 특정 메시지를 수정합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsMessagesUpsertSingle
     * @summary 특정 알고리즘에 특정 메시지 수정
     * @request POST:/v3/api/automations/el/algorithms/messages/upsert/single
     * @secure
     * @response `200` `ApiAutomationsElAlgorithmsMessagesUpsertSingleData` 메시지 수정 성공
     * @response `404` `ApiResponse` 알고리즘 또는 메시지를 찾을 수 없음
     */
    apiAutomationsElAlgorithmsMessagesUpsertSingle: (data: UpdateMessageInput, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsMessagesUpsertSingleData, ApiResponse>({
        path: `/v3/api/automations/el/algorithms/messages/upsert/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘의 특정 메시지를 삭제합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsMessagesDeleteSingle
     * @summary 특정 알고리즘에 특정 메시지 삭제
     * @request POST:/v3/api/automations/el/algorithms/messages/delete/single
     * @secure
     * @response `200` `ApiAutomationsElAlgorithmsMessagesDeleteSingleData` 메시지 삭제 성공
     * @response `404` `ApiResponse` 알고리즘 또는 메시지를 찾을 수 없음
     */
    apiAutomationsElAlgorithmsMessagesDeleteSingle: (data: DeleteMessageInput, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsMessagesDeleteSingleData, ApiResponse>({
        path: `/v3/api/automations/el/algorithms/messages/delete/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘의 활성화 상태를 변경합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsToggle
     * @summary 알고리즘 활성화/비활성화 토글
     * @request POST:/v3/api/automations/el/algorithms/toggle
     * @secure
     * @response `200` `ApiAutomationsElAlgorithmsToggleData` 알고리즘 상태 변경 성공
     * @response `404` `ApiResponse` 알고리즘을 찾을 수 없음
     */
    apiAutomationsElAlgorithmsToggle: (data: AlgorithmToggleInput, params: RequestParams = {}) =>
      this.request<ApiAutomationsElAlgorithmsToggleData, ApiResponse>({
        path: `/v3/api/automations/el/algorithms/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘의 특정 메시지에 대한 응답 목록을 조회합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAlgorithmsResponses
     * @summary 알고리즘 특정 메시지의 응답 목록 조회
     * @request GET:/v3/api/automations/el/algorithms/responses
     * @secure
     * @response `200` `ApiAutomationsElAlgorithmsResponsesData` 응답 목록 조회 성공
     * @response `404` `ApiResponse` 알고리즘 또는 메시지를 찾을 수 없음
     */
    apiAutomationsElAlgorithmsResponses: (
      query: ApiAutomationsElAlgorithmsResponsesParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiAutomationsElAlgorithmsResponsesData, ApiResponse>({
        path: `/v3/api/automations/el/algorithms/responses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 치료 태그가 삭제될 때 영향을 받는 환자 수를 조회합니다.
     *
     * @tags V3-Automation
     * @name ApiAutomationsElAffectedPatientCountWhenTreatmentTagDeleted
     * @summary 특정 치료 태그 삭제 시 영향을 받는 환자 수 조회
     * @request GET:/v3/api/automations/el/affected-patient-count/when-treatment-tag-deleted
     * @secure
     * @response `200` `ApiAutomationsElAffectedPatientCountWhenTreatmentTagDeletedData` 영향을 받는 환자 수 조회 성공
     */
    apiAutomationsElAffectedPatientCountWhenTreatmentTagDeleted: (
      query: ApiAutomationsElAffectedPatientCountWhenTreatmentTagDeletedParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiAutomationsElAffectedPatientCountWhenTreatmentTagDeletedData, any>({
        path: `/v3/api/automations/el/affected-patient-count/when-treatment-tag-deleted`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 알림톡 템플릿 상태를 지정된 대상에 대해 갱신합니다.
     *
     * @tags V3-Automation-Batch
     * @name KakaoTemplateRenewingControllerRenewTemplateStatuses
     * @summary 카카오 알림톡 템플릿 상태 갱신 (대상 지정)
     * @request POST:/v3/api/automations/el/renewing-alimtalk-template-status/targeted
     * @secure
     * @response `200` `KakaoTemplateRenewingControllerRenewTemplateStatusesData` success
     */
    kakaoTemplateRenewingControllerRenewTemplateStatuses: (
      data: KakaoTemplateRenewingControllerRenewTemplateStatusesBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoTemplateRenewingControllerRenewTemplateStatusesData, any>({
        path: `/v3/api/automations/el/renewing-alimtalk-template-status/targeted`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 알고리즘 생성 시 예상되는 대상 수를 조회합니다.
     *
     * @tags V3-Automation
     * @name AlgorithmControllerGetMarkingTargetCount
     * @summary 마케팅 알고리즘 대상 수 조회
     * @request GET:/v3/api/automations/el/count/marketing-algorithm-target
     * @secure
     * @response `200` `AlgorithmControllerGetMarkingTargetCountData` success
     */
    algorithmControllerGetMarkingTargetCount: (
      query: AlgorithmControllerGetMarkingTargetCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerGetMarkingTargetCountData, any>({
        path: `/v3/api/automations/el/count/marketing-algorithm-target`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 알고리즘 생성 시 예상되는 대상 수를 조회합니다.
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerGetMarketingAlgorithmTargetCount
     * @summary 마케팅 알고리즘 대상 수 조회
     * @request POST:/v3/api/automations/el/algorithms/marketing/target-count
     * @secure
     * @response `200` `AlgorithmControllerGetMarketingAlgorithmTargetCountData` success
     */
    algorithmControllerGetMarketingAlgorithmTargetCount: (
      data: AlgorithmControllerGetMarketingAlgorithmTargetCountBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerGetMarketingAlgorithmTargetCountData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/target-count`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드 메시지 마케팅 알고리즘 리스트 조회
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindMarketingAlgorithms
     * @summary 브랜드 메시지 마케팅 알고리즘 리스트 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing
     * @secure
     * @response `200` `AlgorithmControllerFindMarketingAlgorithmsData` success
     */
    algorithmControllerFindMarketingAlgorithms: (params: RequestParams = {}) =>
      this.request<AlgorithmControllerFindMarketingAlgorithmsData, any>({
        path: `/v3/api/automations/el/algorithms/marketing`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 알고리즘을 생성합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerCreateMarketingAlgorithm
     * @summary 마케팅 알고리즘 생성
     * @request POST:/v3/api/automations/el/algorithms/marketing
     * @secure
     * @response `200` `AlgorithmControllerCreateMarketingAlgorithmData` success
     */
    algorithmControllerCreateMarketingAlgorithm: (
      data: AlgorithmControllerCreateMarketingAlgorithmBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerCreateMarketingAlgorithmData, any>({
        path: `/v3/api/automations/el/algorithms/marketing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 알고리즘을 수정합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerUpdateMarketingAlgorithm
     * @summary 마케팅 알고리즘 수정
     * @request PATCH:/v3/api/automations/el/algorithms/marketing
     * @secure
     * @response `200` `AlgorithmControllerUpdateMarketingAlgorithmData` success
     */
    algorithmControllerUpdateMarketingAlgorithm: (
      data: AlgorithmControllerUpdateMarketingAlgorithmBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerUpdateMarketingAlgorithmData, any>({
        path: `/v3/api/automations/el/algorithms/marketing`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드 메시지 마케팅 알고리즘 조회
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindMarketingAlgorithm
     * @summary 브랜드 메시지 마케팅 알고리즘 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/single
     * @secure
     * @response `200` `AlgorithmControllerFindMarketingAlgorithmData` success
     */
    algorithmControllerFindMarketingAlgorithm: (
      query: AlgorithmControllerFindMarketingAlgorithmParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindMarketingAlgorithmData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/single`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 알고리즘 메시지에 대한 정보를 조회합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindAlgorithmMessage
     * @summary 마케팅 자동화 메시지 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/messages/single
     * @secure
     * @response `200` `AlgorithmControllerFindAlgorithmMessageData` success
     */
    algorithmControllerFindAlgorithmMessage: (
      query: AlgorithmControllerFindAlgorithmMessageParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindAlgorithmMessageData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/messages/single`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담자동화 메시지에 대한 통계 정보를 조회합니다
     *
     * @tags ConsultationAutomation
     * @name AlgorithmControllerFindConsultationMessageStats
     * @summary 상담자동화 메시지 통계 조회
     * @request GET:/v3/api/automations/el/algorithms/consultation/messages/stats
     * @secure
     * @response `200` `AlgorithmControllerFindConsultationMessageStatsData` success
     */
    algorithmControllerFindConsultationMessageStats: (
      query: AlgorithmControllerFindConsultationMessageStatsParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindConsultationMessageStatsData, any>({
        path: `/v3/api/automations/el/algorithms/consultation/messages/stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담자동화 메시지 발송 내역을 조회합니다
     *
     * @tags ConsultationAutomation
     * @name AlgorithmControllerFindConsultationMessageSendHistories
     * @summary 상담자동화 메시지 발송 내역 조회
     * @request GET:/v3/api/automations/el/algorithms/consultation/messages/send-histories
     * @secure
     * @response `200` `AlgorithmControllerFindConsultationMessageSendHistoriesData` success
     */
    algorithmControllerFindConsultationMessageSendHistories: (
      query: AlgorithmControllerFindConsultationMessageSendHistoriesParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindConsultationMessageSendHistoriesData, any>({
        path: `/v3/api/automations/el/algorithms/consultation/messages/send-histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 메시지 발송 내역을 조회합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindAlgorithmMessageSendHistories
     * @summary 마케팅 메시지 발송 내역 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/messages/send-histories
     * @secure
     * @response `200` `AlgorithmControllerFindAlgorithmMessageSendHistoriesData` success
     */
    algorithmControllerFindAlgorithmMessageSendHistories: (
      query: AlgorithmControllerFindAlgorithmMessageSendHistoriesParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindAlgorithmMessageSendHistoriesData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/messages/send-histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 메시지 발송 내역을 엑셀(.xlsx) 파일로 다운로드합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcel
     * @summary 마케팅 메시지 발송 내역 엑셀 다운로드
     * @request GET:/v3/api/automations/el/algorithms/marketing/messages/send-histories/excel
     * @secure
     * @response `200` `AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelData` success
     */
    algorithmControllerDownloadAlgorithmMessageSendHistoriesExcel: (
      query: AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerDownloadAlgorithmMessageSendHistoriesExcelData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/messages/send-histories/excel`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담자동화 메시지 발송 내역을 엑셀(.xlsx) 파일로 다운로드합니다
     *
     * @tags ConsultationAutomation
     * @name AlgorithmControllerDownloadConsultationMessageSendHistoriesExcel
     * @summary 상담자동화 메시지 발송 내역 엑셀 다운로드
     * @request GET:/v3/api/automations/el/algorithms/consultation/messages/send-histories/excel
     * @secure
     * @response `200` `AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelData` success
     */
    algorithmControllerDownloadConsultationMessageSendHistoriesExcel: (
      query: AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerDownloadConsultationMessageSendHistoriesExcelData, any>({
        path: `/v3/api/automations/el/algorithms/consultation/messages/send-histories/excel`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상위 마케팅 메시지를 조회합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindTopAlgorithmMessages
     * @summary 상위 마케팅 메시지 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/messages/search-top
     * @secure
     * @response `200` `AlgorithmControllerFindTopAlgorithmMessagesData` success
     */
    algorithmControllerFindTopAlgorithmMessages: (
      query: AlgorithmControllerFindTopAlgorithmMessagesParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindTopAlgorithmMessagesData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/messages/search-top`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 선택가능한 국적 목록을 조회합니다. (현재 환자들에게 적용된 국적만 조회)
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindSelectableNationalities
     * @summary 선택가능한 국적 목록 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/selectable-nationalities
     * @secure
     * @response `200` `AlgorithmControllerFindSelectableNationalitiesData` success
     */
    algorithmControllerFindSelectableNationalities: (params: RequestParams = {}) =>
      this.request<AlgorithmControllerFindSelectableNationalitiesData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/selectable-nationalities`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 알고리즘 메시지들을 조회합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindAlgorithmMessages
     * @summary 알고리즘 메시지 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/messages
     * @secure
     * @response `200` `AlgorithmControllerFindAlgorithmMessagesData` success
     */
    algorithmControllerFindAlgorithmMessages: (
      query: AlgorithmControllerFindAlgorithmMessagesParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindAlgorithmMessagesData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원의 브랜드메시지 전송 현황을 조회합니다
     *
     * @tags KakaoBrandMessage
     * @name AlgorithmControllerFindStatistics
     * @summary 브랜드메시지 전송 현황 조회
     * @request GET:/v3/api/automations/el/algorithms/marketing/statistics
     * @secure
     * @response `200` `AlgorithmControllerFindStatisticsData` success
     */
    algorithmControllerFindStatistics: (params: RequestParams = {}) =>
      this.request<AlgorithmControllerFindStatisticsData, any>({
        path: `/v3/api/automations/el/algorithms/marketing/statistics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 진행 중인 상담 자동화 목록을 조회합니다
     *
     * @tags V3-Automation
     * @name AlgorithmControllerFindOngoingAutomations
     * @summary 진행 중인 상담 자동화 목록 조회
     * @request GET:/v3/api/automations/ongoing
     * @secure
     * @response `200` `AlgorithmControllerFindOngoingAutomationsData` success
     */
    algorithmControllerFindOngoingAutomations: (params: RequestParams = {}) =>
      this.request<AlgorithmControllerFindOngoingAutomationsData, any>({
        path: `/v3/api/automations/ongoing`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자별 자동화·재진마케팅 발송 내역 조회
     *
     * @tags V3-Automation
     * @name AlgorithmControllerFindPatientMessageHistories
     * @summary 환자 발송 내역 조회
     * @request GET:/v3/api/automations/el/patients/message-histories
     * @secure
     * @response `200` `AlgorithmControllerFindPatientMessageHistoriesData` success
     */
    algorithmControllerFindPatientMessageHistories: (
      query: AlgorithmControllerFindPatientMessageHistoriesParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerFindPatientMessageHistoriesData, any>({
        path: `/v3/api/automations/el/patients/message-histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상담자동화 sentMessageCount 전체 재계산(백필). 운영이 1회 실행.
     *
     * @tags ConsultationAutomation
     * @name AlgorithmControllerBackfillConsultationSentCount
     * @summary 상담자동화 발송 건수 백필
     * @request POST:/v3/api/automations/el/algorithms/consultation/sent-count/backfill
     * @secure
     * @response `200` `AlgorithmControllerBackfillConsultationSentCountData` success
     */
    algorithmControllerBackfillConsultationSentCount: (
      query: AlgorithmControllerBackfillConsultationSentCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AlgorithmControllerBackfillConsultationSentCountData, any>({
        path: `/v3/api/automations/el/algorithms/consultation/sent-count/backfill`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료 태그 목록을 선택하면 상담 자동화 생성이 가능한 대상 국적 리스트를 조회합니다.
     *
     * @tags V3-Automation
     * @name TargetableNationalitiesHandler
     * @summary 치료 태그 목록으로 상담 자동화 생성이 가능한 대상 국적 리스트 조회
     * @request GET:/v3/api/automations/el/targetable_nationalities/with-treatment-tags
     * @secure
     * @response `200` `TargetableNationalitiesHandlerData` success
     */
    targetableNationalitiesHandler: (query: TargetableNationalitiesHandlerParams, params: RequestParams = {}) =>
      this.request<TargetableNationalitiesHandlerData, any>({
        path: `/v3/api/automations/el/targetable_nationalities/with-treatment-tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘의 단일 메시지를 조회합니다.
     *
     * @tags V3-Automation
     * @name SingleAlgorithmMessageHandler
     * @summary 특정 알고리즘의 단일 메시지 조회 - 이전 메시지 불러오기
     * @request GET:/v3/api/automations/el/algorithms/messages/single/find
     * @secure
     * @response `200` `SingleAlgorithmMessageHandlerData` success
     */
    singleAlgorithmMessageHandler: (query: SingleAlgorithmMessageHandlerParams, params: RequestParams = {}) =>
      this.request<SingleAlgorithmMessageHandlerData, any>({
        path: `/v3/api/automations/el/algorithms/messages/single/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 단일 알고리즘 데이터를 조회합니다.
     *
     * @tags V3-Automation
     * @name SingleAlgorithmHandler
     * @summary 특정 단일 알고리즘 데이터 조회
     * @request GET:/v3/api/automations/el/algorithms/single/find
     * @secure
     * @response `200` `SingleAlgorithmHandlerData` success
     */
    singleAlgorithmHandler: (query: SingleAlgorithmHandlerParams, params: RequestParams = {}) =>
      this.request<SingleAlgorithmHandlerData, any>({
        path: `/v3/api/automations/el/algorithms/single/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 알고리즘의 특정 단일 설문 메시지에 대한 응답을 제출합니다.
     *
     * @tags V3-Automation
     * @name SubmittingSurveyResponseHandler
     * @summary 특정 알고리즘의 특정 단일 설문 메시지 응답 제출
     * @request POST:/v3/api/automations/m/algorithms/messages/survey-response
     * @secure
     * @response `200` `SubmittingSurveyResponseHandlerData` success
     */
    submittingSurveyResponseHandler: (data: SubmittingSurveyResponseHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<SubmittingSurveyResponseHandlerData, any>({
        path: `/v3/api/automations/m/algorithms/messages/survey-response`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 채팅방에 환자 대상 설문을 생성합니다.
     *
     * @tags V3-Automation-Test
     * @name GeneratingSurveyHandler
     * @summary 특정 채팅방에 환자 대상 설문 생성
     * @request POST:/v3/api/automations/m/algorithms/messages/generating-survey
     * @secure
     * @response `200` `GeneratingSurveyHandlerData` success
     */
    generatingSurveyHandler: (data: GeneratingSurveyHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<GeneratingSurveyHandlerData, any>({
        path: `/v3/api/automations/m/algorithms/messages/generating-survey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 자동화 메인 데이터를 수정합니다.
     *
     * @tags V3-Automation
     * @name UpdateAlgorithmMainDataHandler
     * @summary 특정 자동화 메인 데이터 수정
     * @request PATCH:/v3/api/automations/el/algorithms/main
     * @secure
     * @response `200` `UpdateAlgorithmMainDataHandlerData` success
     */
    updateAlgorithmMainDataHandler: (data: UpdateAlgorithmMainDataHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<UpdateAlgorithmMainDataHandlerData, any>({
        path: `/v3/api/automations/el/algorithms/main`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 알림톡 템플릿 상태를 갱신하는 배치입니다.
     *
     * @tags V3-Automation-Batch
     * @name RenewingKakaoTemplateStatusBatchHandler
     * @summary 카카오 알림톡 템플릿 상태 갱신 배치
     * @request POST:/v3/api/automations/el/renewing-alimtalk-template-status/batch
     * @secure
     * @response `200` `RenewingKakaoTemplateStatusBatchHandlerData` 成功响应
     */
    renewingKakaoTemplateStatusBatchHandler: (params: RequestParams = {}) =>
      this.request<RenewingKakaoTemplateStatusBatchHandlerData, any>({
        path: `/v3/api/automations/el/renewing-alimtalk-template-status/batch`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description 특정 일자의 자동화 메세지를 발송합니다.
     *
     * @tags V3-Automation
     * @name QaAutomationSendTriggerHandler
     * @summary 특정 일자의 자동화 메세지를 발송
     * @request POST:/v3/api/automations/el/qa/send
     * @secure
     * @response `200` `QaAutomationSendTriggerHandlerData` success
     */
    qaAutomationSendTriggerHandler: (data: QAAutomationSendTriggerHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<QaAutomationSendTriggerHandlerData, any>({
        path: `/v3/api/automations/el/qa/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자 기준의 자동화 적용 목록을 조회합니다..
     *
     * @tags V3-Automation
     * @name QaAutomationAppliedListHandler
     * @summary 자동화 적용 목록을 조회
     * @request POST:/v3/api/automations/el/qa/applied
     * @secure
     * @response `200` `QaAutomationAppliedListHandlerData` success
     */
    qaAutomationAppliedListHandler: (data: QAAutomationAppliedListHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<QaAutomationAppliedListHandlerData, any>({
        path: `/v3/api/automations/el/qa/applied`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자 기준의 예약된 자동화 메시지 목록을 조회합니다..
     *
     * @tags V3-Automation
     * @name QaAutomationReservedMessageListHandler
     * @summary 예약된 자동화 메시지 목록을 조회
     * @request POST:/v3/api/automations/el/qa/reserved
     * @secure
     * @response `200` `QaAutomationReservedMessageListHandlerData` success
     */
    qaAutomationReservedMessageListHandler: (
      data: QAAutomationReservedMessageListHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<QaAutomationReservedMessageListHandlerData, any>({
        path: `/v3/api/automations/el/qa/reserved`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
